export const CompletedStatus = 'completed';
export const CompletedStatusLabel = 'Submitted';
export const UnopenedStatus = 'unopened';
export const ReviewingStatus = 'reviewing';
export const ReviewingStatusLabel = 'In Progress';
export const ReviewedStatus = 'reviewed';
export const WithdrawnStatus = 'withdrawn';

const AttestationStatus = {
    isReadOnly: (status) => {
        return status.toLowerCase() === CompletedStatus || status.toLowerCase() === ReviewedStatus || status.toLowerCase() === WithdrawnStatus;
    },

    canBeReopened: (status) => {
        return status.toLowerCase() === CompletedStatus;
    }
}

export default AttestationStatus;